import { ActivityEntityName, DomainType, StockLocation } from '@jms/model';
import type { EntityManifestCard } from '@workbuddy/services/entities/entity.manifest';
import { registerManifest } from '@workbuddy/services/entities/entity.manifest.registry';

// Stock Location entity manifest. Card-only: locations are picked and displayed as references from
// equipment/stock records, with no board or page of their own; the same card serves both portals.
const card: EntityManifestCard<StockLocation> = {
  component: () => import('./presentation/card.stock.location').then(module => module.CardStockLocationComponent),
  resolution: 'snapshot',
  summarize: value => ({ title: value.name ?? 'Not set' }),
};

export const stockLocationManifest = registerManifest<StockLocation>({
  entity: ActivityEntityName.StockLocation,
  slug: 'stock-location',
  presentation: { card },
  domains: {
    [DomainType.ClientPortal]: { presentation: { card } },
    [DomainType.ContractorPortal]: { presentation: { card } },
  },
});
